import React from 'react'
import StatusFilters from '../../common/StatusFilters'

export default function Filters({
  items = [],
  activeStatus = '',
  onStatusChange,
  viewMode = 'my',
  children, // For Toolbar section
  isDark = false,
}) {
  const getStatusIcon = (status) => {
    const iconMap = {
      My: '/assets/icons/mysubmissions.svg',
      Related: '/assets/icons/relatedsubmissions.svg',
      Complete: '/assets/icons/completed.svg',
      All: '/assets/icons/allsubmissions.svg',
      '': '/assets/icons/allsubmissions.svg',
      Pending: '/assets/icons/pending.svg',
      Cancelled: '/assets/icons/canceled.svg',
      Issues: '/assets/icons/issues.svg',
      Error: '/assets/icons/error.svg',
      Scheduled: '/assets/icons/scheduled.svg',
      pending_pdf: '/assets/icons/pending.svg',
      ready_to_send: '/assets/icons/pending.svg',
      needs_review: '/assets/icons/pending.svg',
      emailed: '/assets/icons/completed.svg',
      posted: '/assets/icons/completed.svg',
      failed_permanent: '/assets/icons/error.svg',
    }
    return iconMap[status] || null
  }

  const mappedItems = items.map((item) => {
    const id = item.status;

    const activeStyleMap = {
      My: 'bg-[#CD6D2C] text-white hover:bg-[#b85e24]',
      Related: 'bg-[#32047c] text-white hover:bg-[#26035e]',
      All: 'bg-black text-white hover:bg-opacity-90',
      '': 'bg-black text-white hover:bg-opacity-90',
      Complete: 'bg-[#0a6e29] text-white hover:bg-[#095a23]',
      Pending: 'bg-[#dca900] text-white hover:bg-[#c39400]',
      Cancelled: 'bg-[#b42318] text-white hover:bg-[#9c1e15]',
      Issues: 'bg-purple-700 text-white hover:bg-purple-800',
      Error: 'bg-orange-600 text-white hover:bg-orange-700',
      Scheduled: 'bg-[#3e62e2] text-white hover:bg-[#3554c0]',
      pending_pdf: 'bg-[#dca900] text-white hover:bg-[#c39400]',
      ready_to_send: 'bg-[#4b5563] text-white hover:bg-[#374151]',
      needs_review: 'bg-purple-700 text-white hover:bg-purple-800',
      emailed: 'bg-[#0a6e29] text-white hover:bg-[#095a23]',
      posted: 'bg-[#0a6e29] text-white hover:bg-[#095a23]',
      failed_permanent: 'bg-[#b42318] text-white hover:bg-[#9c1e15]',
    };

    const inactiveStyleMap = {
      My: 'bg-[#fff5eb] text-[#CD6D2C] hover:bg-[#CD6D2C]',
      Related: 'bg-[#e3d2fe] text-[#32047c] hover:bg-[#32047c]',
      All: 'bg-[#F3F4F6] text-black hover:!bg-black hover:!text-white',
      '': 'bg-[#F3F4F6] text-black hover:!bg-black hover:!text-white',
      Complete: 'bg-[#d9fbe6] text-[#0a6e29] hover:bg-[#0a6e29]',
      Pending: 'bg-[#fff9db] text-[#9a7b00] hover:bg-[#dca900]',
      Cancelled: 'bg-[#ffe3e3] text-[#b42318] hover:bg-[#b42318]',
      Issues: 'bg-[#f9e3ff] text-purple-700 hover:bg-purple-700',
      Error: 'bg-[#ffe0cc] text-orange-700 hover:bg-orange-600',
      Scheduled: 'bg-[#dae3ff] text-[#3e62e2] hover:bg-[#3e62e2]',
      pending_pdf: 'bg-[#fff9db] text-[#9a7b00] hover:bg-[#dca900]',
      ready_to_send: 'bg-[#e5e7eb] text-[#4b5563] hover:bg-[#4b5563]',
      needs_review: 'bg-[#f9e3ff] text-purple-700 hover:bg-purple-700',
      emailed: 'bg-[#d9fbe6] text-[#0a6e29] hover:bg-[#0a6e29]',
      posted: 'bg-[#d9fbe6] text-[#0a6e29] hover:bg-[#0a6e29]',
      failed_permanent: 'bg-[#ffe3e3] text-[#b42318] hover:bg-[#b42318]',
    };

    const inactiveIconClassMap = {
      My: 'bg-[#CD6D2C]',
      Related: 'bg-[#32047c]',
      All: 'bg-[#000000]',
      '': 'bg-[#000000]',
      Complete: 'bg-[#0a6e29]',
      Pending: 'bg-[#9a7b00]',
      Cancelled: 'bg-[#b42318]',
      Issues: 'bg-purple-700',
      Error: 'bg-orange-700',
      Scheduled: 'bg-[#3e62e2]',
      pending_pdf: 'bg-[#9a7b00]',
      ready_to_send: 'bg-[#4b5563]',
      emailed: 'bg-[#0a6e29]',
      posted: 'bg-[#0a6e29]',
      failed_permanent: 'bg-[#b42318]',
    };

    const activeIconClassMap = {
      All: 'bg-white',
      '': 'bg-white',
    };

    return {
      id: id,
      label: item.buttonLabel,
      icon: getStatusIcon(id),
      activeStyle: `${activeStyleMap[id] || ''} font-semibold`,
      activeIconClass: activeIconClassMap[id] || 'bg-white',
      inactiveStyle: `${inactiveStyleMap[id] || ''} font-medium hover:text-white`,
      inactiveIconClass: inactiveIconClassMap[id] || 'bg-gray-700',
    }
  });

  let computedActiveStatus = [];

  if (viewMode === 'my') {
    computedActiveStatus.push('My');
  } else if (viewMode === 'related') {
    computedActiveStatus.push('Related');
  } else if (viewMode === 'all') {
    computedActiveStatus.push('All');
  }

  if (activeStatus === 'All') {
    if (!viewMode) computedActiveStatus.push('All');
  } else if (activeStatus === 'My') {
    if (!viewMode) computedActiveStatus.push('My');
  } else {
    computedActiveStatus.push(activeStatus);
  }

  return (
    <StatusFilters
      items={mappedItems}
      activeStatus={computedActiveStatus}
      onStatusChange={onStatusChange}
      isDark={isDark}
    >
      {children}
    </StatusFilters>
  )
}